// extracted by mini-css-extract-plugin
export default {"container":"dR-z","topReviewHeading":"eR-z","criticalReview":"fR-z","favorableReview":"gR-z","vsSeparator":"hR-z"};